<main class="flex-1">
	<router-outlet></router-outlet>
</main>
@if (showFooter()) {
<app-footer></app-footer>
}